<div class="flex flex-col gap-1">
  @if (!hasPharmacies()) {
    <app-no-pharmacies />
  } @else {
    <app-hero-section [pharmacyId]="selectedPharmacy()?.id ?? null" />
  }
  <app-offers />
  @if (hasPharmacies()) {
    <app-categories-section />
  }
  <app-companies-section />
  @if (hasPharmacies()) {
    <app-incoming-products />
  }
</div>
